import styled from '@emotion/styled';

export const Title = styled.h2`
  font-size: ${props => props.theme.fontSizes.large};
`;
